// extracted by mini-css-extract-plugin
export var inset = "riveAnimation-module--inset--a41ed";
export var rive = "riveAnimation-module--rive--5961e";